import React, { useContext } from 'react';

import LoadingPage from '../../components/LoadingPage';
import ChatChannelContext from './ChatChannelContext';
import ChatChannelContextProvider from './ChatChannelContextProvider';

const withChatChannelContextProvider = (Component) => (props) => (
  <ChatChannelContextProvider>
    <Component {...props} />
  </ChatChannelContextProvider>
);

const withChatChannelContextProviderReady = (Component) => (props) => {
  const { isReady } = useContext(ChatChannelContext);

  return isReady ? <Component {...props} /> : <LoadingPage />;
};

export {
  withChatChannelContextProvider,
  withChatChannelContextProviderReady,
};
